// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-messenger {
    display: flex;
    flex-direction: row;
}

.contact-messenger .contact-messenger__icon {
    margin-top: 0.1rem;
    border-radius: 50%;
    cursor: pointer;
}

.contact-messenger p {
    margin: 0;
    margin-left: 4px;
}

.contact-messenger__detach-button {
    background: none;
    line-height: normal;
    color: #039be5;
    box-shadow: none;
    padding: 0;
    margin-left: 0.6rem;
    height: auto;
    text-transform: none;
    font-size: 1rem;
}

.contact-messenger__detach-button:hover {
    background: none;
    box-shadow: none;

}

.contact-messenger__detach-button:focus {
    background: none;
    box-shadow: none;
}

.contact-messenger__id {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline;
}`, "",{"version":3,"sources":["webpack://./src/app/contact/contact-main/contact-list/contact-item/contact-messengers/ContactMessengers.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,UAAU;IACV,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;;AAEpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB","sourcesContent":[".contact-messenger {\r\n    display: flex;\r\n    flex-direction: row;\r\n}\r\n\r\n.contact-messenger .contact-messenger__icon {\r\n    margin-top: 0.1rem;\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n}\r\n\r\n.contact-messenger p {\r\n    margin: 0;\r\n    margin-left: 4px;\r\n}\r\n\r\n.contact-messenger__detach-button {\r\n    background: none;\r\n    line-height: normal;\r\n    color: #039be5;\r\n    box-shadow: none;\r\n    padding: 0;\r\n    margin-left: 0.6rem;\r\n    height: auto;\r\n    text-transform: none;\r\n    font-size: 1rem;\r\n}\r\n\r\n.contact-messenger__detach-button:hover {\r\n    background: none;\r\n    box-shadow: none;\r\n\r\n}\r\n\r\n.contact-messenger__detach-button:focus {\r\n    background: none;\r\n    box-shadow: none;\r\n}\r\n\r\n.contact-messenger__id {\r\n    display: inline-block;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    display: inline;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
